import React, { useEffect, useState } from 'react';
import { CssBaseline, makeStyles, Tooltip, Typography, TextField, FormControl, Select, MenuItem, Box, IconButton, Checkbox } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { FormatDate } from '@/shared/components/FormatDate';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { styled } from '@mui/material/styles';
import { Clear } from '@material-ui/icons';
const CompactDateTimePicker = styled(DateTimePicker)({
    '& .MuiInputBase-root': {
        fontSize: '0.75rem',
    },
    '& .MuiInputBase-input': {
        padding: '2px 0',
    },
    '& .MuiSvgIcon-root': {
        width: '0.8em',
        height: '0.8em',
    },
});
const uuid = (index) => `${Math.random()}_${index ? index : Math.random()}_${new Date().getTime()}`;
const columns = [
    { value: 'messageId', label: 'ИД сообщения', minWidth: 290 },
    { value: 'chainType', label: 'Тип процесса', minWidth: 190 },
    {
        value: 'startDate',
        label: 'Дата начала',
        minWidth: 200,
        component: (startDate) => React.createElement(FormatDate, { date: startDate }),
    },
    { value: 'currentStage', label: 'Текущий этап' },
    { value: 'stateOnHead', label: 'Состояние Head' },
    { value: 'stateOnAgents', label: 'Состояние Agent' },
    {
        value: 'integrationChainState',
        label: 'Статус',
        component: (integrationChainState) => {
            switch (integrationChainState) {
                case 'Processing':
                    return 'В работе';
                case 'Waiting':
                    return 'Ожидание от внешней системы';
                case 'Issue':
                    return 'Инцидент';
                case 'Investigating':
                    return 'Ожидание решение инцидента';
                case 'Abandoned':
                    return 'Прекращена';
                case 'Completed':
                    return 'Завершена';
                default:
                    return integrationChainState;
            }
        },
    },
    { value: 'endDate', label: 'Дата окончания', minWidth: 200, component: (endDate) => React.createElement(FormatDate, { date: endDate }) },
    { value: 'executionResultComment', label: 'Комментарий' },
];
const columnsMessageStages = [
    {
        value: 'startDate',
        label: 'Дата начала',
        minWidth: 150,
        component: (startDate) => React.createElement(FormatDate, { date: startDate }),
    },
    { value: 'stageType', label: 'Тип этапа', minWidth: 80 },
    { value: 'stageCode', label: 'Код этапа', minWidth: 120 },
    { value: 'status', label: 'Статус', minWidth: 180 },
    {
        value: 'endDate',
        label: 'Дата выполнения',
        minWidth: 140,
        component: (endDate) => React.createElement(FormatDate, { date: endDate }),
    },
    { value: 'executionComment', label: 'Комментарий' },
];
const columnsDescriptionItems = [
    {
        value: 'createdAtDateTimeUtc',
        label: 'Записан',
        component: (date) => React.createElement(FormatDate, { date: date }),
    },
    {
        value: 'modifiedAtDateTimeUtc',
        label: 'Модифицирован',
        component: (date) => React.createElement(FormatDate, { date: date }),
    },
    { value: 'key', label: 'Ключ' },
    { value: 'value', label: 'Значение' },
];
export const rowsPerPageSetting = [10, 30, 50, 100, 1000];
const useStyles = makeStyles(() => ({
    root: {
        width: 'auto',
        height: 'auto',
    },
    container: {
        overflow: 'hidden',
        minWidth: 650,
    },
    tableRow: {
        cursor: 'pointer',
        padding: '5px 16px 5px 16px',
        fontSize: '0.8rem',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        borderRadius: '0px',
        tableLayout: 'auto',
        lineHeight: '1.5rem',
    },
    tableParentHead: {
        cursor: 'pointer',
        padding: '5px 16px 5px 16px',
        fontSize: '0.8rem',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        borderRadius: '0px',
        tableLayout: 'auto',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        fontWeight: 'bolder',
        borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
    tableParentRow: {
        cursor: 'pointer',
        background: '#fafafa',
    },
    colorForKeyValue: {
        color: '#3f51b5',
    },
    statusFailed: {
        background: '#F08080',
    },
    statusCompleted: {
        background: '#8FBC8F',
    },
    statusInvestigating: {
        background: '#FFB347',
    },
    statusRetry: {
        background: '#ADD8E6',
    },
    subTableRow: {
        background: '#e8f5e9',
    },
    marginBott: {
        marginTop: '1rem',
        marginBottom: '1rem',
        marginLeft: '1rem',
    },
    pageInput: {
        width: '150px',
    },
}));
export const MonitoringInfoTable = ({ dashboards, onClickRow, totalPages, pageSize, currentPage, onChangePage, onChangeRowsPerPage, columnFilters, onColumnFilterChange, startDate, endDate, onStartDateChange, onEndDateChange, filterOptions, selectedIds, onSelectRow, onSelectAll }) => {
    const styles = useStyles();
    const [, forceUpdate] = useState({});
    // Черновик номера страницы - применяется по Enter или потере фокуса, а не на каждый символ.
    const [pageDraft, setPageDraft] = useState(String(currentPage));
    useEffect(() => {
        setPageDraft(String(currentPage));
    }, [currentPage]);
    const applyPageDraft = () => {
        const parsed = Number(pageDraft);
        if (!Number.isInteger(parsed)) {
            setPageDraft(String(currentPage));
            return;
        }
        const nextPage = Math.min(Math.max(parsed, 1), Math.max(totalPages, 1));
        setPageDraft(String(nextPage));
        if (nextPage !== currentPage) {
            onChangePage(nextPage);
        }
    };
    const handlePageKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            applyPageDraft();
        }
    };
    const handleChangePage = (_, newPage) => {
        onChangePage(newPage + 1);
    };
    const handleChangeRowsPerPage = (event) => {
        onChangeRowsPerPage(Number(event.target.value));
    };
    return (React.createElement(Paper, { elevation: 3 },
        React.createElement(CssBaseline, null),
        React.createElement(TableContainer, { className: styles.container },
            React.createElement(Typography, { variant: "h4", className: styles.marginBott }, "\u041C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433"),
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { className: styles.tableParentHead },
                            React.createElement(Checkbox, { indeterminate: selectedIds.length > 0 && selectedIds.length < (dashboards?.dashboardInfos?.length || 0), checked: (dashboards?.dashboardInfos?.length || 0) > 0 && selectedIds.length === dashboards?.dashboardInfos?.length, onChange: (e) => {
                                    if (e.target.checked) {
                                        const allIds = dashboards?.dashboardInfos?.map(item => item.messageId) || [];
                                        onSelectAll(allIds);
                                    }
                                    else {
                                        onSelectAll([]);
                                    }
                                } })),
                        columns.map((column, index) => (React.createElement(TableCell, { key: uuid(index), align: column.align, className: styles.tableParentHead, style: { width: column.minWidth } },
                            column.value !== 'startDate' && React.createElement("div", null, column.label),
                            ['chainType', 'currentStage', 'stateOnHead', 'stateOnAgents', 'integrationChainState'].includes(column.value) && (React.createElement(FormControl, { size: "small", fullWidth: true, onClick: (e) => e.stopPropagation() },
                                React.createElement(Select, { value: columnFilters[column.value], onChange: (e) => onColumnFilterChange(column.value, e.target.value), displayEmpty: true, variant: "standard" },
                                    React.createElement(MenuItem, { value: "" },
                                        React.createElement("em", null, "\u0412\u0441\u0435")),
                                    filterOptions[column.value]?.map((option) => (React.createElement(MenuItem, { key: option, value: option }, column.value === 'integrationChainState' ? (column.component ? column.component(option) : option) : option))) || null))),
                            column.value === 'startDate' && (React.createElement(Box, { onClick: (e) => e.stopPropagation(), display: "flex", flexDirection: "column" },
                                React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                                    React.createElement("div", null, column.label),
                                    React.createElement(IconButton, { size: "small", onClick: () => {
                                            onStartDateChange(null);
                                            onEndDateChange(null);
                                        }, title: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0434\u0430\u0442\u044B" },
                                        React.createElement(Clear, { style: { fontSize: '1rem' } }))),
                                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                    React.createElement(Box, { display: "flex", alignItems: "center" },
                                        React.createElement(Typography, { style: { fontSize: '0.75rem', marginRight: '4px' } }, "\u0441"),
                                        React.createElement(CompactDateTimePicker, { ampm: false, format: 'DD/MM/YYYY HH:mm', value: startDate, onChange: (value) => onStartDateChange(value), slotProps: {
                                                textField: {
                                                    size: 'small',
                                                    variant: 'standard',
                                                    fullWidth: true,
                                                    style: { marginTop: 0 }
                                                }
                                            } })),
                                    React.createElement(Box, { display: "flex", alignItems: "center" },
                                        React.createElement(Typography, { style: { fontSize: '0.75rem', marginRight: '4px' } }, "\u043F\u043E"),
                                        React.createElement(CompactDateTimePicker, { ampm: false, format: 'DD/MM/YYYY HH:mm', value: endDate, onChange: (value) => onEndDateChange(value), slotProps: {
                                                textField: {
                                                    size: 'small',
                                                    variant: 'standard',
                                                    fullWidth: true,
                                                    style: { marginTop: 0 }
                                                }
                                            } })))))))))),
                React.createElement(TableBody, null, dashboards?.dashboardInfos?.map((item, index) => (React.createElement(React.Fragment, { key: item.messageId || uuid(index) },
                    React.createElement(TableRow, { className: `${styles.tableRow} ${item.integrationChainState === 'Completed' ? styles.statusCompleted : ''} ${item.integrationChainState === 'Investigating' ? styles.statusInvestigating : ''}`, key: uuid(index), hover: true, onClick: () => onClickRow(item) },
                        React.createElement(TableCell, { className: styles.tableRow, onClick: (e) => e.stopPropagation() },
                            React.createElement(Checkbox, { checked: selectedIds.includes(item.messageId), onChange: () => onSelectRow(item.messageId) })),
                        columns.map((column, index) => {
                            if (column.value === 'stateOnAgents') {
                                return (React.createElement(TableCell, { key: uuid(index), align: column.align, "data-test": column.value, className: styles.tableRow, style: { width: column.minWidth } }, item.stateOnAgents?.map((element, i) => (React.createElement("div", { key: uuid(i) },
                                    element.agentName,
                                    ":",
                                    element.state))) || null));
                            }
                            const value = item[column.value];
                            return (React.createElement(TableCell, { key: uuid(index), align: column.align, "data-test": column.value, className: styles.tableRow, style: { width: column.minWidth } }, (column.component && column.component(value)) || value));
                        })),
                    item.isShowStageInfo ? (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 10 },
                            React.createElement(Table, null,
                                React.createElement(TableHead, null,
                                    React.createElement(TableRow, null, columnsMessageStages.map((column, index) => (React.createElement(TableCell, { key: uuid(index), align: column.align, className: styles.tableParentHead }, column.label))))),
                                React.createElement(TableBody, null, item.messageStage?.stagesInfo?.map((stage, index) => (React.createElement(React.Fragment, { key: uuid(index) },
                                    React.createElement(TableRow, { className: stage.nextStageStrategy === 'Error' ? styles.statusInvestigating :
                                            stage.nextStageStrategy === 'DoRetry' ? styles.statusRetry :
                                                styles.statusCompleted, key: uuid(index), onClick: (e) => {
                                            e.stopPropagation();
                                            if (stage.messageDescriptionItems && stage.messageDescriptionItems.length > 0) {
                                                item.expandedStageIndex = item.expandedStageIndex === index ? undefined : index;
                                                forceUpdate({});
                                            }
                                        } }, columnsMessageStages.map((column, index) => {
                                        const lengthSimbolExecutionComment = 10;
                                        const value = stage[column.value];
                                        return (React.createElement(Tooltip, { key: uuid(index), title: (column.label === 'Комментарий' && stage.executionComment !== null && stage.executionComment.length >=
                                                lengthSimbolExecutionComment) ? stage.executionComment : '', placement: "right", interactive: true },
                                            React.createElement(TableCell, { align: column.align, className: styles.tableRow }, (column.component &&
                                                column.component(value)) ||
                                                (column.label === 'Комментарий' && stage.executionComment !== null && stage.executionComment.length >=
                                                    lengthSimbolExecutionComment ? `${value.slice(0, 20)}...` : value))));
                                    })),
                                    item.expandedStageIndex === index && stage.messageDescriptionItems && stage.messageDescriptionItems.length > 0 && (React.createElement(TableRow, { className: styles.subTableRow },
                                        React.createElement(TableCell, { colSpan: 6 },
                                            React.createElement(Table, { size: "small" },
                                                React.createElement(TableHead, null,
                                                    React.createElement(TableRow, null, columnsDescriptionItems.map((col, idx) => (React.createElement(TableCell, { key: uuid(idx), className: styles.tableParentHead }, col.label))))),
                                                React.createElement(TableBody, null, stage.messageDescriptionItems.map((descItem, descIdx) => (React.createElement(TableRow, { key: uuid(descIdx) }, columnsDescriptionItems.map((col, idx) => {
                                                    const val = descItem[col.value];
                                                    return (React.createElement(TableCell, { key: uuid(idx), className: styles.tableRow }, (col.component && col.component(val)) || val));
                                                }))))))))))))))))) : null)))))),
        (dashboards?.totalCount ?? 0) > 0 && (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "flex-end", pl: 2 },
            React.createElement(TextField, { className: styles.pageInput, size: "small", variant: "outlined", type: "number", label: `Страница из ${totalPages}`, inputProps: { min: 1, max: totalPages }, value: pageDraft, onChange: (event) => setPageDraft(event.target.value), onBlur: applyPageDraft, onKeyDown: handlePageKeyDown }),
            React.createElement(TablePagination, { labelRowsPerPage: 'Cтрок на странице', rowsPerPageOptions: rowsPerPageSetting, component: "div", count: dashboards?.totalCount ?? 0, rowsPerPage: pageSize, page: currentPage - 1, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage })))));
};
